import classNames from "classnames";
import { DComponent } from "../DComponent";

class DToast extends DComponent {
  constructor({
    parent,
    id,
    type = DToast.TYPE.DEFAULT,
    message = "",
    autoDismiss = true,
    autoDismissDelay = 4000,
    transitionDuration = 500,
    delay,
    onCallBack = () => { },
    fixedPosition = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("DToast", {
        "fixed-position": fixedPosition,
      }),
    });
    this.type = type;
    this.message = message;
    this.autoDismiss = autoDismiss;
    this.autoDismissDelay = autoDismissDelay;
    this.transitionDuration = transitionDuration;
    this.delay = delay;
    this.currentTime = undefined;
    this.onCallBack = onCallBack;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "DToast");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  before() {
    this.parent.css("position", "relative");
  }

  after() {
    this.fillData();

    $('.close', this.element).on('click', () => {
      this.element.attr("status", "hide");
    });
  }

  /** @param {DToast} _params */
  updateAttributes(_params = {}) {
    Object.keys(_params).forEach(key => {
      this[key] = _params[key];
    });
    this.fillData();
  }

  fillData() {
    this.element.attr("type", this.type);
    $(".message", this.element).html(this.message);

    if (typeof this.onCallBack === "function") {
      $(".message", this.element).off("click")
      $(".message", this.element).on("click", (e) => {
        e.preventDefault();
        this.onCallBack();
        this.element.attr("status", "hide");
      })
    }
  }

  show() {
    let delay = this.delay > 0 ? this.delay * 1000 : this.autoDismissDelay;
    if (!this.currentTime || Date.now() > this.currentTime + delay) {
      this.currentTime = Date.now();
      setTimeout(() => {
        this.element.attr("status", "show");
      }, this.transitionDuration);

      if (this.autoDismiss) {
        this.hide();
      }
    }
  }

  hide() {
    setTimeout(() => {
      this.element.attr("status", "hide");
    }, this.autoDismissDelay);
  }

  static TYPE = {
    DEFAULT: 'default',
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
  }
}

export default DToast;